import React, { useEffect } from 'react';

const ScrollAnimation = ({ children }: { children: React.ReactNode }) => {
	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('visible');
					}
				});
			},
			{ threshold: 0.1 }
		);

		const sections = document.querySelectorAll('.section-fade');
		sections.forEach((section) => {
			observer.observe(section);
		});

		return () => {
			sections.forEach((section) => {
				observer.unobserve(section);
			});
		};
	}, []);

	return <>{children}</>;
};

export default ScrollAnimation;
